import { Directive, Input } from "@angular/core";
import {
    ComponentActionTypes,
    Job,
    Page,
    TemplateRow,
    TriggeredComponentAction,
    VoyseBaseGridComponent,
    VoyseComponent,
} from "@interfaces";
import { ComponentActionsService } from "../services/component-actions.service";

@Directive()
export class AbstractComponent {
    @Input() noTracking = false;
    @Input() editMode = false;
    @Input() templateLocked = false;
    @Input() componentIndex: number = null;
    @Input() rowIndex: number = null;
    @Input() gridIndex: number = null;
    @Input() moveable = true;
    @Input() published = false;
    @Input() mobileMode = false;
    @Input() job: Job;
    @Input() page: Page;
    @Input() component: VoyseComponent;
    @Input() fullWidth = false;
    @Input() row: TemplateRow;
    @Input() lang: string;
    public isHighlighted = false;

    constructor(protected actionsService: ComponentActionsService) {
        this.actionsService.componentActionReceived.subscribe((value: TriggeredComponentAction) => {
            switch (value.action) {
                case ComponentActionTypes.COMPONENT_HIGHLIGHTED:
                    this.isHighlighted =
                        value.rowIndex === this.rowIndex && value.componentIndex === this.componentIndex;
                    break;
                case ComponentActionTypes.GRID_COMPONENT_HIGHLIGHTED:
                    this.isHighlighted =
                        value.rowIndex === this.rowIndex &&
                        value.componentIndex === this.componentIndex &&
                        value.gridIndex === this.gridIndex;
                    break;
            }
        });
    }

    public triggerEditComponent() {
        this.actionsService.triggerComponentAction({
            action: ComponentActionTypes.EDIT_COMPONENT,
            componentIndex: this.componentIndex,
            rowIndex: this.rowIndex,
            gridIndex: this.component,
        });
    }

    public getWidth() {
        return this.mobileMode ? this.component.mobile_colspan * 256 : this.component.colspan * 512;
    }

    public getHeight() {
        return this.mobileMode
            ? (this.component as VoyseBaseGridComponent).mobile_rowspan * 256
            : (this.component as VoyseBaseGridComponent).rowspan * 512;
    }

    public getAccentColourAsStyle(
        color: "primaryAccentColor" | "secondaryAccentColor",
        selector: "background" | "border" | "text" = "background"
    ) {
        switch (selector) {
            case "background":
                return {
                    "background-color": (this.job || this.page)?.[color],
                };
            case "border":
                return {
                    "border-color": (this.job || this.page)?.[color],
                };
            case "text":
                return {
                    color: (this.job || this.page)?.[color],
                };
        }
    }
}
